import _ from 'lodash';

import { createGetPropGetter } from '@/store/utils';
import { emptyProject, initNewProjectNavigation } from '@/constants/projects';

export default {
  storedNewProject: createGetPropGetter('storedNewProject', _.cloneDeep(emptyProject)),
  storedNewProjectNavigation: createGetPropGetter('storedNewProjectNavigation', _.cloneDeep(initNewProjectNavigation)),
};
